import axios from "axios";

// Instance khusus endpoint publik: tidak memasang header X-Auth-Token dan
// tidak memakai interceptor sesi member.
const servicePublic = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 50000,
  headers: {
    "Content-Type": "application/json"
  }
});

servicePublic.interceptors.response.use(
  response => {
    const res = response.data;
    if (!res || Number(res.status) !== 200) {
      const error = new Error((res && res.msg) || "Request failed");
      error.response = {
        status: Number(res && res.status) || 500,
        data: res
      };
      return Promise.reject(error);
    }
    return res;
  },
  error => Promise.reject(error)
);

export default servicePublic;



// WEBPACK FOOTER //
// ./src/utils/requestPublic.js